import { CSSResultGroup, css } from 'lit';
import { LitElement, html } from 'lit-element';
import { customElement, property } from 'lit/decorators.js';
import styles from './nile-loader.css';

@customElement('nile-loader')
export class NileLoader extends LitElement {

  @property({ type: String }) height = '50';
  @property({ type: String }) width = '50';
  @property({ type: String }) position = 'absolute';
  @property({ type: String }) margin = '';

  static override styles: CSSResultGroup = styles;

  override render() {
    return html`
      <div
        style="width: ${this.width}px; height: ${this.height}px; background-size: ${this.width}px; position: ${this.position}; margin: ${this.margin}"
        class="nile-loader"
      ></div>
    `;
  }
}
